export default class ClientModel {
    constructor({id, client, is_active, created_by, created_by_name}) {
        this.id = id;
        this.gambar = client;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
    }
}